// Single seam between non-React code (sagas, AuthModule, utility functions) and the
// router. Components should use withNavigation or react-router's own hooks; everything
// else goes through here. routes.js binds the data router at startup.
let router = null

export const bindRouter = (dataRouter) => {
  router = dataRouter
}

const boundRouter = () => {
  if (!router) {
    throw new Error('navigation: no router bound. Call bindRouter(router) from routes.js first.')
  }

  return router
}

export const navigateTo = (path) => boundRouter().navigate(path)

export const replaceWith = (path) => boundRouter().navigate(path, { replace: true })

export const goBack = () => boundRouter().navigate(-1)

export const currentPath = () => boundRouter().state.location.pathname
